import { HANDOFF_BEAT_IDS, type HandoffBeatId } from "./handoffTypes";

/**
 * V3.0.4 两步 App tour：有 parked goal → [parkedGoal, firstBrief]；无 → [firstBrief]。
 * （取代 V3.0.3 三步 handoff，去掉了 territory 步）
 */
export function buildHandoffBeats(hasGoal = true): HandoffBeatId[] {
  return hasGoal
    ? [HANDOFF_BEAT_IDS.parkedGoal, HANDOFF_BEAT_IDS.firstBrief]
    : [HANDOFF_BEAT_IDS.firstBrief];
}
